import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import decorate from 'core-decorators/lib/decorate';

import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { getAllSettings } from 'shared/selectors/app-settings';

import { selectVideo } from 'widget/redux/client/actions/select-video';

import MobileCarousel from 'widget/components/mobile-carousel/mobile-carousel';
import { SimpleVideoThumbnail } from 'widget/components/thumbnail/simple';
import { ActiveMobileThumbnail } from 'widget/components/thumbnail/mobile-thumb';
import Clickable from 'shared/containers/clickable/clickable';


const SLIDES_PREVIEW_WIDTH = 20;


@connect(state => ({
  videoIds: state.lazyVideoLists.mobileWidget.videoIds,
  videoByIds: getVideosGroupedByIds(state),
  appSettings: getAllSettings(state),
}), {
  selectVideo,
})
export default class VideosListMobile extends React.Component {

  static propTypes = {
    videoIds: React.PropTypes.array,
    videoByIds: React.PropTypes.object,
    appSettings: React.PropTypes.object,
    loadMore: React.PropTypes.func,
    selectVideo: React.PropTypes.func,
    currentChannelId: React.PropTypes.string,
    selectedVideoId: React.PropTypes.string,
    onVideoItemClicked: React.PropTypes.func,
    className: React.PropTypes.string,
  };

  static defaultProps = {
    onVideoItemClicked: _.noop,
  };

  static childContextTypes = {
    appSettings: React.PropTypes.object,
  };

  state = {
    selectedVideoId: null,
  };

  getChildContext() {
    return {
      appSettings: this.props.appSettings,
    };
  }

  @autobind
  setCurrentVideo(videoId) {
    this.props.selectVideo(videoId);
  }

  @decorate(_.memoize)
  handleThumbnailClick(id) {
    return () => {
      this.props.onVideoItemClicked(id);
      this.setCurrentVideo(id);
    };
  }

  // TODO extract into component
  @autobind
  renderVideoThumb(videoData) {
    const { selectedVideoId } = this.props;
    const { id } = videoData;

    const Thumbnail = id === selectedVideoId ? ActiveMobileThumbnail : SimpleVideoThumbnail;

    return (
      <Clickable key={id}
                 onClick={this.handleThumbnailClick(id)}>
        <Thumbnail video={videoData} />
      </Clickable>
    );
  }

  getHeight(elem, width) {
    return width * 9 / 16;
  }

  @autobind
  afterChange(leftVisibleSlideIndex) {
    const { videosInRow } = this.props.appSettings.numbers;
    const { loadMore } = this.props;
    const slidesShown = leftVisibleSlideIndex + videosInRow;
    loadMore(slidesShown);
  }

  render() {
    const { videoIds, videoByIds, className } = this.props;
    const { videosInRow } = this.props.appSettings.numbers;
    const shouldPreviewSlides = _.size(videoIds) > videosInRow;

    return (
      <MobileCarousel afterChange={this.afterChange}
                      getHeight={this.getHeight}
                      slidesToShow={videosInRow}
                      slidesPreviewWidth={shouldPreviewSlides ? SLIDES_PREVIEW_WIDTH : 0}
                      className={className}>
        {
          _(videoIds)
            .map(vid => videoByIds[vid])
            .map(this.renderVideoThumb)
            .value()
        }
      </MobileCarousel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/videos-list-mobile/videos-list-mobile.js